import "./TechnicalIndicatorsKeyStatsComponent.scss";
import {IComponentOptions} from "angular";
import {TechnicalStatistics} from "../../models/TechnicalStatistics";

export const KeyStats = "technicalIndicatorsKeyStats";

export function keyStats(): IComponentOptions {
    return {
        templateUrl: "app/trading-systems/components/key-stats/TechnicalIndicatorsKeyStatsComponent.html",
        bindings: {
            statistics: "<"
        },
        controllerAs: "ctrl",
        controller: TechnicalIndicatorsKeyStatsComponentController
    };
}

export class TechnicalIndicatorsKeyStatsComponentController {
    public statistics: TechnicalStatistics;
}
